import { render } from "./App.vue?vue&type=template&id=4e2caf70"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4e2caf70&lang=scss"

import exportComponent from "/Users/walleka/projektit/2022-02-aluevaalit-vaalikonevastaukset/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__